import { useEffect, useState } from 'react';
import config from '../../utils/apiUrl';
import formatMoney from '../../utils/formatMoney';

const useTopTable = ({company}, group) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const columns = [
    {
      name: group === 'foundation' ? 'Fundación' : 'Campaña',
      selector: (row) => row.groupName,
      sortable: true,
    },
    {
      name: 'Monto Total',
      selector: (row) => row.totalAmount,
      sortable: true,
    },
    {
      name: 'Cantidad de Donaciones',
      selector: (row) => row.totalDonations,
      sortable: true,
    },
  ];
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${
            config.apiUrl
          }/company/admin/getTopGroup?company=${company}&groupBy=${encodeURIComponent(
            group
          )}`
        );

        if (!response.ok) {
          throw new Error(`Error en la solicitud: ${response.statusText}`);
        }
        const result = await response.json();
        const formattedData = (result.payments || []).map((item) => ({
          ...item,
          totalAmount: formatMoney(item.totalAmount),
        }));

        setData(formattedData);
      } catch (err) {
        const errorMessage =
          err.message ||
          'Ocurrió un error inesperado al cargar las donaciones agrupadas.';
        setError(errorMessage);
        console.error('Error:', errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [company, group]);

  return { columns, data, loading, error };
};
export default useTopTable;
